angular.module("warsApp.factories").factory("requestTransformer", function () {

    var isObject = function(itemUnderTest) {
        return typeof itemUnderTest == "object" && itemUnderTest !== null;
    };

    var setUndefinedVariablesToNullRecursively = function(object) {
        for (var propertyKey in object) {
            if (isObject(object[propertyKey])) {
                setUndefinedVariablesToNullRecursively(object[propertyKey]);
            }
            if (object[propertyKey] === undefined) {
                object[propertyKey] = null;
            }
        }
    };

    var propertyNamesToScrub = [];

    var scrubDataRecursively = function (object) {
        for (var propertyKey in object) {
            if (propertyNamesToScrub.indexOf(propertyKey) != -1) {
                delete object[propertyKey];
            }
            else if (isObject(object[propertyKey])) {
                scrubDataRecursively(object[propertyKey]);
            }
        }
    };

    var factory = {};

    // Had issues with MVC model binding being too ambitious and binding a single property that was sent up to multiple action method argument objects. 
    // Adding this transform request before the default request transformer ensures undefined properties and changed to null properties and 
    // thus posted to the server.  This ensures that MVC will model bind these objects as null and not try to find any sub properties that match
    // anything else posted.
    factory.setUndefinedVariablesToNull = function(payload) {
        var deepCopy = angular.copy(payload);
        setUndefinedVariablesToNullRecursively(deepCopy);
        return deepCopy;
    };

    factory.scrubDataFromPost = function(payload) {
        var deepCopy = angular.copy(payload);
        scrubDataRecursively(deepCopy);
        return deepCopy;
    }

    return factory;
});